import type { ReactElement } from "react"
import { useParams } from "react-router"
import { PlayerPage } from "~/features/player/components/PlayerPage"
import { useEventDetail } from "../api/useEventDetail"

/**
 * Playback for a digital event session. Only the standard feed is projected —
 * ASL, Spanish and open-caption feeds are a later decision, and the OTT frame's
 * `sliders` control is where they will land.
 */
export const EventPlayerPage = (): ReactElement => {
  const { id, sessionId } = useParams()
  const detail = useEventDetail(id)

  return (
    <PlayerPage
      detail={detail}
      sessionId={sessionId}
      detailHref={`/event/${id ?? ""}`}
      sessionsTitle="All Sessions"
      notFoundMessage="We couldn't find that event in your library."
      qaHook="event-player"
    />
  )
}
